export default {"src":"/_next/static/media/form-editor-report.8491885f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};